var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{staticClass:"mt-2"},_vm._l((_vm.panels),function(panel,index){return _c('v-expansion-panel',{key:index},[_c('v-expansion-panel-header',{staticClass:"px-4"},[_c('core-title',{attrs:{"title":panel.title}})],1),_c('v-expansion-panel-content',[_c('v-sheet',{domProps:{"innerHTML":_vm._s(panel.content)}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }